import { ICycle } from 'v2/resources/types/cycles';
import {
  IResponseBiometricParameters,
  IResponseBiometricsNurseries,
  IResponseHealthMortality,
  IResponseNurseryMortality,
  IResponseQualityParameters,
  IResponseSupply,
  IResponseWaterAnalysisNurseries,
} from 'v2/resources/types/graphics';
import { INursery } from 'v2/resources/types/nurseries';
import { IGetUsersResponse } from 'v2/resources/types/users';

export interface IDataChatSlice {
  default: string;
  cycles: Array<ICycle>;
  nurseries: Array<INursery>;
  graphicSupply: IResponseSupply;
  graphicNurseryMortality: IResponseNurseryMortality[];
  graphicHealthAnalysis: IResponseHealthMortality;
  graphicQualityParameters: IResponseQualityParameters;
  graphicBiometricsParameters: IResponseBiometricParameters;
  graphicBiometricsNurseries: IResponseBiometricsNurseries;
  graphicWaterAnalysisNurseries: IResponseWaterAnalysisNurseries;
  users: IGetUsersResponse[];
}
export const initialState: IDataChatSlice = {
  default: '',
  cycles: [],
  nurseries: [],
  graphicSupply: {
    data: [],
    labels: [],
  },
  graphicNurseryMortality: [],
  graphicHealthAnalysis: {
    info: [],
    labels: [],
  },
  graphicQualityParameters: {
    info: [],
    labels: [],
  },
  graphicBiometricsParameters: {
    info: [],
    labels: [],
  },
  graphicBiometricsNurseries: {
    info: [],
    labels: [],
  },
  graphicWaterAnalysisNurseries: {
    info: [],
    labels: [],
  },
  users: [],
};
